import { HTTP_DESKRH } from '../http';

export default {

  getMasks() {
    return HTTP_DESKRH.get(`${process.env.API_MASK}`)
      .then(data => data.data.data);
  },
};



// WEBPACK FOOTER //
// ./src/api/masks.js